<template>
  <b-modal
    id="form-chatmessage"
    :visible="shallShowChatmessageFormModal"
    :title="`${$t('Form')} ${$t('Chat Message')}`"
    footer-class="d-flex justify-content-between"
    size="xl"
    centered
    no-close-on-backdrop
    @change="(val) => $emit('update:shall-show-chatmessage-form-modal', val)"
  >
    <!-- Modal Header -->
    <template #modal-header>
      <h5 class="modal-title">
        {{ `${$t(typeChatmessageForm)} ${$t('Chat Message')}` }}
      </h5>
      <div class="modal-actions">
        <feather-icon
          icon="MinusIcon"
          class="cursor-pointer"
          @click="(busy === false) ? $emit('update:shall-show-chatmessage-form-modal', false) : false"
        />
        <!-- <feather-icon
          icon="Maximize2Icon"
          class="ml-1 cursor-pointer"
        /> -->
        <feather-icon
          icon="XIcon"
          class="ml-1 cursor-pointer"
          @click="(busy === false) ? onDiscard() : false"
        />
      </div>
    </template>

    <!-- Modal Footer -->
    <template #modal-footer>
      <!-- Footer: Left Content -->
      <div>
        <b-button
          v-if="(typeChatmessageForm !== 'View')"
          ref="submit"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          right
          :disabled="busy"
          @click="onSubmit"
        >
          {{ $t('Save Data') }}
        </b-button>
      </div>

      <!-- Footer: Right Content -->
      <div>
        <!-- Discard -->
        <feather-icon
          icon="XCircleIcon"
          size="17"
          class="ml-75 cursor-pointer"
          @click="(busy === false) ? onDiscard() : false"
        />
      </div>
    </template>

    <!-- Modal: Body -->
    <validation-observer
      #default="{ handleSubmit }"
      ref="refFormObserver"
    >
      <div>
        <b-form
          ref="refForm"
          class="position-relative"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
          <div>
            <b-card style="margin-bottom: 0.6rem;">
              <div>
                <b-row>
                  <b-col cols="6">

                    <b-row>
                      <!-- Field: Name -->
                      <b-col
                        cols="12"
                      >
                        <b-form-group
                          v-if="(typeChatmessageForm === 'Add' || typeChatmessageForm === 'Edit')"
                          :label="$t('Name')"
                          label-for="chatmessage-name"
                        >
                          <validation-provider
                            #default="validationContext"
                            :name="$t('Name')"
                            rules="required"
                          >
                            <b-form-input
                              id="chatmessage-name"
                              v-model="chatmessageData.name"
                              :state="getValidationState(validationContext)"
                              :disabled="busy"
                            />
                            <small class="text-danger">{{ validationContext.errors[0] }}</small>
                          </validation-provider>

                        </b-form-group>

                        <b-form-group
                          v-else
                          :label="$t('Name')"
                          label-for="chatmessage-name"
                        >
                          <span class="form-info-box">{{ chatmessageData.name }}</span>
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <b-row>
                      <!-- Field: Select Message Type -->
                      <b-col
                        cols="12"
                      >
                        <b-form-group
                          v-if="typeChatmessageForm === 'Add'"
                          :label="`${$t('Select Message Type')} (${$t('Chat Message')})`"
                          style="margin-bottom: 0.5rem;"
                        >
                          <b-button
                            v-for="cmType in chatmessageData.chatmessageType"
                            :key="cmType.value"
                            style="margin-bottom: 0.5rem; margin-right: 0.8rem;"
                            size="sm"
                            :variant="(chatmessageData.type === cmType.value)? 'info' : 'outline-info'"
                            @click="onSelectChatMessageType(cmType.value)"
                          >
                            {{ cmType.name }}
                          </b-button>
                        </b-form-group>

                        <b-form-group
                          v-if="typeChatmessageForm === 'Edit'"
                          :label="`${$t('Select Message Type')} (${$t('Chat Message')})`"
                          style="margin-bottom: 0.5rem;"
                        >
                          <b-button
                            v-model="chatmessageData.type"
                            style="margin-bottom: 0.5rem; margin-right: 0.8rem;"
                            size="sm"
                            variant="info"
                          >
                            {{ chatmessageData.type_name }}
                          </b-button>
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <b-row
                      v-if="(typeChatmessageForm === 'Add' || typeChatmessageForm === 'Edit')"
                    >
                      <!-- Field: AltText/Text -->
                      <b-col
                        cols="12"
                      >
                        <b-form-group
                          v-if="chatmessageData.type === 'flex'"
                          :label="`${$t('Alternative Text')}`"
                          label-for="chatmessage-chatmessage-flex"
                        >
                          <validation-provider
                            #default="validationContext"
                            :name="$t('Alternative Text')"
                            rules="required"
                          >
                            <b-form-textarea
                              v-model="chatmessageData.altText"
                              rows="1"
                              :placeholder="$t('Alternative Text')"
                              @keyup="keyupAltText"
                            />
                            <small class="text-danger">{{ validationContext.errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>

                        <b-form-group
                          v-if="chatmessageData.type === 'text'"
                          :label="`${$t('Text Message')}`"
                          label-for="chatmessage-chatmessage-text"
                        >
                          <b-form-textarea
                            v-model="chatmessageData.textMessage"
                            rows="1"
                            :placeholder="$t('Text Message')"
                            @keyup="keyupTextMessage"
                          />
                        </b-form-group>

                        <b-form-group
                          v-if="chatmessageData.type === 'imagemap'"
                          :label="`${$t('Base Url')}`"
                          label-for="chatmessage-chatmessage-imagemap"
                        >
                          <b-form-input
                            v-model="chatmessageData.baseUrl"
                            :placeholder="$t('Base Url')"
                            @change="changeBaseUrl"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <b-row
                      v-if="(typeChatmessageForm === 'Add' || typeChatmessageForm === 'Edit')"
                    >
                      <!-- Field: Description::AltText/Text -->
                      <b-col
                        cols="12"
                      >
                        <span v-if="chatmessageData.type === 'flex'">
                          ดูรายละเอียดวิธีปรับแต่ง Flex Message ตามต้องการด้วย JSON
                          <a
                            href="https://developers.line.biz/flex-simulator/"
                            target="_blank"
                          >
                            <feather-icon
                              icon="ExternalLinkIcon"
                              size="18"
                              style="margin-top: -4px;"
                            />
                            สร้าง Flex Message
                          </a>
                        </span>
                        <span v-if="chatmessageData.type === 'text'">
                          ป้อนข้อความที่ต้องการ JSON จะสร้างขึ้นมาอัตโนมัติ
                        </span>
                      </b-col>
                    </b-row>

                    <b-row class="mt-1">

                      <!-- Field: Source JSON Message -->
                      <b-col
                        cols="12"
                      >
                        <b-form-group
                          v-if="(typeChatmessageForm === 'Add' || typeChatmessageForm === 'Edit')"
                        >
                          <validation-provider
                            #default="validationContext"
                            :name="`${$t('JSON Message')}`"
                            rules="required"
                          >
                            <b-row>
                              <b-col
                                cols="6"
                                class="d-flex align-items-center justify-content-start"
                              >
                                <span>{{ `${$t('JSON Message')} (${$t('Source')})` }}</span>
                              </b-col>
                              <b-col
                                cols="6"
                                class="d-flex align-items-center justify-content-end m-0 p-0"
                              >
                                <b-button
                                  size="sm"
                                  class="mr-1"
                                  style="margin-bottom: 0.5rem;"
                                  variant="danger"
                                  @click="onClear"
                                >
                                  {{ $t('Clear') }}
                                </b-button>
                                <b-button
                                  size="sm"
                                  class="mr-1"
                                  style="margin-bottom: 0.5rem;"
                                  variant="success"
                                  @click="onPaste"
                                >
                                  {{ $t('Paste') }}
                                </b-button>
                              </b-col>
                            </b-row>
                            <v-jsoneditor
                              v-model="chatmessageData.source"
                              :options="optionsSourceJson"
                              :plus="false"
                              height="300px"
                              @error="onErrorSourceJson"
                            />
                            <small class="text-danger">{{ validationContext.errors[0] }}</small>
                          </validation-provider>

                        </b-form-group>

                        <b-form-group
                          v-else
                          :label="`${$t('JSON Message')} (${$t('Source')})`"
                          label-for="chatmessage-source"
                        >
                          <v-jsoneditor
                            v-model="chatmessageData.source"
                            :options="optionsViewMessage"
                            :plus="false"
                            height="300px"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <b-row
                      class="mt-1"
                    >

                      <!-- Field: Message JSON Message -->
                      <b-col
                        cols="12"
                      >
                        <b-row>
                          <b-col
                            cols="6"
                            class="d-flex align-items-center justify-content-start"
                          >
                            <span>{{ `${$t('JSON Message')} (${$t('Line Message')})` }}</span>
                          </b-col>
                          <b-col
                            cols="6"
                            class="d-flex align-items-center justify-content-end m-0 p-0"
                          >
                            <b-button
                              size="sm"
                              class="mr-1"
                              style="margin-bottom: 0.5rem;"
                              variant="warning"
                              @click="onCopy"
                            >
                              {{ $t('Copy') }}
                            </b-button>
                            <b-button
                              size="sm"
                              class="mr-1"
                              style="margin-bottom: 0.5rem;"
                              variant="secondary"
                              @click="toggleShowLineMessage"
                            >
                              {{ (isShowLineMessage === false)? $t('Show Line Message') : $t('Hide Line Message') }}
                            </b-button>
                          </b-col>
                        </b-row>
                        <v-jsoneditor
                          v-if="isShowLineMessage"
                          v-model="chatmessageData.message"
                          :options="optionsViewMessage"
                          :plus="false"
                          height="300px"
                          read-only
                        />
                      </b-col>
                    </b-row>

                  </b-col>
                  <b-col cols="6">
                    <line-chat-message
                      :data="jsonMessage"
                      @action="onAction"
                    />
                    <div
                      v-if="chatmessageData.type === 'flex' && actionData !== null"
                      class="mt-1"
                    >
                      <b-form-group
                        :label="$t('Type')"
                      >
                        <b-form-input
                          v-model="actionData.type"
                        />
                      </b-form-group>
                      <b-form-group
                        :label="$t('Label')"
                      >
                        <b-form-input
                          v-model="actionData.label"
                        />
                      </b-form-group>
                      <b-form-group
                        v-if="actionData.type === 'uri'"
                        :label="$t('URI')"
                      >
                        <b-form-input
                          v-model="actionData.uri"
                        />
                      </b-form-group>
                      <b-form-group
                        v-if="actionData.type === 'message' || actionData.type === 'postback'"
                        :label="$t('Text')"
                      >
                        <b-form-input
                          v-model="actionData.text"
                        />
                      </b-form-group>

                      <b-form-group
                        v-if="actionData.type === 'postback' || actionData.type === 'datetimepicker'"
                        :label="$t('Data')"
                      >
                        <b-form-input
                          v-model="actionData.data"
                        />
                      </b-form-group>
                      <b-form-group
                        v-if="actionData.type === 'datetimepicker'"
                        :label="$t('Mode')"
                      >
                        <b-form-input
                          v-model="actionData.mode"
                        />
                      </b-form-group>
                      <b-form-group
                        v-if="actionData.type === 'datetimepicker'"
                        :label="$t('Initial')"
                      >
                        <b-form-input
                          v-model="actionData.initial"
                        />
                      </b-form-group>
                      <b-form-group
                        v-if="actionData.type === 'datetimepicker'"
                        :label="$t('Max')"
                      >
                        <b-form-input
                          v-model="actionData.max"
                        />
                      </b-form-group>
                      <b-form-group
                        v-if="actionData.type === 'datetimepicker'"
                        :label="$t('Min')"
                      >
                        <b-form-input
                          v-model="actionData.min"
                        />
                      </b-form-group>
                    </div>
                    <div
                      v-if="chatmessageData.type === 'imagemap' && actionData !== null"
                      class="mt-1"
                    >
                      <div>
                        <b-tabs>
                          <b-tab
                            v-for="(action, index) in actionData"
                            :key="index"
                            :title="`${$t('Area')} ${index+1}`"
                          >
                            <div
                              style="border-radius: 0.8rem; border: 1px solid #eeeeee; padding: 12px 12px 12px 12px; margin-bottom: 0.5rem;"
                            >
                              <b-form-group
                                v-if="action.area"
                                :label="$t('Area')"
                              >
                                <div
                                  style="border: 1px solid #eeeeee; padding: 12px 12px 12px 12px; margin-bottom: 0.5rem;"
                                >
                                  <b-row>
                                    <b-col
                                      v-for="(value, key) in action.area"
                                      :key="key"
                                    >
                                      <span>{{ key }}</span>
                                      <b-form-input
                                        :value="value"
                                        style="margin-top: 5px;"
                                      />
                                    </b-col>
                                  </b-row>
                                </div>
                              </b-form-group>
                              <b-form-group
                                v-if="action.type"
                                :label="$t('Type')"
                              >
                                <b-form-input
                                  v-model="action.type"
                                />
                              </b-form-group>
                              <b-form-group
                                v-if="action.text && action.type === 'message'"
                                :label="$t('Text')"
                              >
                                <b-form-input
                                  v-model="action.text"
                                />
                              </b-form-group>
                              <b-form-group
                                v-if="action.linkUri && action.type === 'uri'"
                                :label="$t('Link Uri')"
                              >
                                <b-form-input
                                  v-model="action.linkUri"
                                />
                              </b-form-group>
                              <b-form-group
                                v-if="action.data && action.type === 'postback'"
                                :label="$t('Data')"
                              >
                                <b-form-input
                                  v-model="action.data"
                                />
                              </b-form-group>
                            </div>
                          </b-tab>
                        </b-tabs>
                      </div>
                    </div>
                  </b-col>
                </b-row>

              </div>
            </b-card>
          </div>

        </b-form>

      </div>

    </validation-observer>

    <b-overlay
      :show="busy"
      no-wrap
      @shown="onShown"
      @hidden="onHidden"
    >
      <template #overlay>
        <div
          v-if="processing"
          class="text-center p-2 bg-primary text-light rounded"
        >
          <feather-icon
            icon="UploadCloudIcon"
            size="20"
          />
          <div class="mb-2">
            {{ `${$t('Processing')}...` }}
          </div>
          <b-progress
            min="1"
            max="10"
            :value="counter"
            variant="success"
            height="6px"
            class="mx-n1"
          />
        </div>
        <div
          v-else
          ref="dialog"
          tabindex="-1"
          role="dialog"
          aria-modal="false"
          aria-labelledby="form-confirm-label"
          class="text-center p-3"
        >
          <b-card-text
            class="font-weight-bolder"
          >
            {{ $t('Are you sure?') }}
          </b-card-text>
          <div class="d-flex">
            <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="outline-danger"
              class="mr-3"
              @click="onCancel"
            >
              {{ $t('Cancel') }}
            </b-button>
            <b-button
              v-ripple.400="'rgba(40, 199, 111, 0.15)'"
              variant="outline-success"
              @click="onOK"
            >
              {{ $t('Ok') }}
            </b-button>
          </div>
        </div>
      </template>
    </b-overlay>
  </b-modal>
</template>

<script>
import {
  BButton, BForm,
  BFormGroup, BFormInput,
  BRow,
  BCol,
  BCard,
  BOverlay,
  BProgress,
  BCardText,
  BFormTextarea,
  BTab,
  BTabs,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import {
  ValidationProvider,
  ValidationObserver,
} from 'vee-validate'
import formValidation from '@core/comp-functions/forms/form-validation'
import { required } from '@validations'
import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import VJsoneditor from 'v-jsoneditor'
import LineChatMessage from '@core/components/line-chat-message/LineChatMessage.vue'

export default {
  directives: {
    Ripple,
  },
  components: {
    LineChatMessage,

    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BOverlay,
    BRow,
    BCol,
    BCard,
    BProgress,
    BCardText,
    BFormTextarea,
    BTab,
    BTabs,

    ValidationProvider,
    ValidationObserver,
    FeatherIcon,
    VJsoneditor,
  },
  model: {
    prop: 'shallShowChatmessageFormModal',
    event: 'update:shall-show-chatmessage-form-modal',
  },
  props: {
    shallShowChatmessageFormModal: {
      type: Boolean,
      required: true,
    },
    typeChatmessageForm: {
      type: String,
      default: 'Add',
    },
    chatmessageData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      required,
      busy: false,
      processing: false,
      counter: 1,
      interval: null,
      skin: store.state.appConfig.layout.skin,
      optionsSourceJson: {
        mode: 'code',
        mainMenuBar: true,
        enableSort: false,
        enableTransform: false,
        statusBar: false,
      },
      optionsViewMessage: {
        mode: 'code',
        mainMenuBar: false,
        enableSort: false,
        enableTransform: false,
        statusBar: false,
      },
      jsonMessage: {},
      actionData: null,
      isShowLineMessage: false,
    }
  },
  computed: {
    lineOa() {
      const value = store.state.lineapi.lineOa
      if (value === '' || value === undefined) {
        return ''
      }
      return JSON.parse(value)
    },
    lineOaId() {
      const value = this.lineOa.id
      if (value === '' || value === undefined) {
        return ''
      }
      return value
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    'chatmessageData.source': function (newValue) {
      const { type } = newValue
      if (type === 'bubble' || type === 'carousel' || type === 'flex') {
        this.chatmessageData.type = 'flex'
      } else if (type) {
        const found = this.chatmessageData.chatmessageType.find(({ value }) => value === type)
        if (found) {
          this.chatmessageData.type = type
        } else {
          this.chatmessageData.type = 'flex'
        }
      } else {
        this.chatmessageData.type = 'flex'
      }

      if (this.chatmessageData.type === 'flex') {
        this.chatmessageData.message = {
          type: 'flex',
          altText: this.chatmessageData.altText,
          contents: this.chatmessageData.source,
        }
      } else {
        this.chatmessageData.message = this.chatmessageData.source
      }
    },
    // eslint-disable-next-line func-names
    'chatmessageData.message': function (newValue) {
      if (newValue !== '' && newValue !== null) {
        this.actionData = null
        if (this.chatmessageData.type === 'flex') {
          if (this.chatmessageData.message.contents !== '') {
            this.jsonMessage = newValue
          } else {
            this.jsonMessage = {}
          }
        } else {
          this.jsonMessage = newValue
        }
        if (this.chatmessageData.type === 'imagemap') {
          const { actions, baseUrl } = this.chatmessageData.message
          this.actionData = actions
          this.chatmessageData.baseUrl = baseUrl
        } else if (this.chatmessageData.type === 'text') {
          const { text } = this.chatmessageData.message
          if (text !== '') {
            this.chatmessageData.textMessage = text
          }
        }
      } else {
        this.jsonMessage = {}
      }
    },
  },
  methods: {
    onShown() {
      // Focus the dialog prompt
      this.$refs.dialog.focus()
    },
    onHidden() {
      // In this case, we return focus to the submit button
      // You may need to alter this based on your application requirements
      this.$refs.submit.focus()
    },
    onSubmit() {
      this.$refs.refFormObserver.validate().then(success => {
        if (success) {
          this.processing = false
          this.busy = true
        }
      })
    },
    onCancel() {
      this.busy = false
    },
    onOK() {
      this.processing = true
      if (this.typeChatmessageForm === 'Add') {
        this.chatmessageData.lineOaId = this.lineOaId
        store.dispatch('chatmessage-store/addChatmessage', this.chatmessageData)
          .then(() => {
            const okMsg = this.$i18n.t('Process on successfully')
            this.$toast({
              component: ToastificationContent,
              props: {
                title: okMsg,
                icon: 'CheckCircleIcon',
                variant: 'success',
              },
            },
            {
              position: 'bottom-right',
            })
            this.busy = false
            this.processing = false

            this.$emit('update-chatmessage-form')
            this.$emit('update:shall-show-chatmessage-form-modal', false)
          })
          .catch(error => {
            const { response, message } = error
            if (response) {
              const errorMsg = this.$i18n.t(response.data.error)
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: errorMsg,
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
              },
              {
                position: 'bottom-right',
              })
            } else if (message) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: error.message,
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
              },
              {
                position: 'bottom-right',
              })
            }
            this.busy = false
            this.processing = false
          })
      } else if (this.typeChatmessageForm === 'Edit') {
        store.dispatch('chatmessage-store/editChatmessage', { id: this.chatmessageData.id, data: this.chatmessageData })
          .then(() => {
            const okMsg = this.$i18n.t('Process on successfully')
            this.$toast({
              component: ToastificationContent,
              props: {
                title: okMsg,
                icon: 'CheckCircleIcon',
                variant: 'success',
              },
            },
            {
              position: 'bottom-right',
            })
            this.busy = false
            this.processing = false

            this.$emit('update-chatmessage-form')
            this.$emit('update:shall-show-chatmessage-form-modal', false)
          })
          .catch(error => {
            const { response, message } = error
            if (response) {
              const errorMsg = this.$i18n.t(response.data.error)
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: errorMsg,
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
              },
              {
                position: 'bottom-right',
              })
            } else if (message) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: error.message,
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
              },
              {
                position: 'bottom-right',
              })
            }
            this.busy = false
            this.processing = false
          })
      } else if (this.typeChatmessageForm === 'Delete') {
        store.dispatch('chatmessage-store/deleteChatmessage', {
          id: this.chatmessageData.id,
        })
          .then(() => {
            const okMsg = this.$i18n.t('Process on successfully')
            this.$toast({
              component: ToastificationContent,
              props: {
                title: okMsg,
                icon: 'CheckCircleIcon',
                variant: 'success',
              },
            },
            {
              position: 'bottom-right',
            })
            this.busy = false
            this.processing = false

            this.$emit('update-chatmessage-form')
            this.$emit('update:shall-show-chatmessage-form-modal', false)
          })
          .catch(error => {
            const { response, message } = error
            if (response) {
              const errorMsg = this.$i18n.t(response.data.error)
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: errorMsg,
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
              },
              {
                position: 'bottom-right',
              })
            } else if (message) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: error.message,
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
              },
              {
                position: 'bottom-right',
              })
            }
            this.busy = false
            this.processing = false
          })
      }
    },
    onDiscard() {
      this.$emit('discard-chatmessage-form')
      this.$emit('update:shall-show-chatmessage-form-modal', false)
    },
    onErrorSourceJson() {
      // console.log('error')
    },
    onSelectChatMessageType(type) {
      this.chatmessageData.type = type
      this.chatmessageData.source = ''
      this.chatmessageData.message = ''
      if (type === 'text' && this.chatmessageData.textMessage !== '') {
        this.keyupTextMessage()
      }
    },
    keyupAltText() {
      if (this.chatmessageData.type === 'flex') {
        this.chatmessageData.message = {
          type: 'flex',
          altText: this.chatmessageData.altText,
          contents: this.chatmessageData.source,
        }
      }
    },
    keyupTextMessage() {
      this.chatmessageData.source = {
        type: 'text',
        text: this.chatmessageData.textMessage,
      }
      this.chatmessageData.message = this.chatmessageData.source
    },
    changeBaseUrl() {
      if (this.chatmessageData.source !== '' && this.chatmessageData.source?.baseUrl) {
        this.chatmessageData.source.baseUrl = this.chatmessageData.baseUrl
        this.chatmessageData.message = this.chatmessageData.source
      }
    },
    onPaste() {
      navigator.clipboard
        .readText()
        .then(
          cliptext => {
            try {
              this.chatmessageData.source = JSON.parse(cliptext)
            } catch (e) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$i18n.t('Invalid JSON Format'),
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
              },
              {
                position: 'bottom-right',
              })
            }
          },
          err => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: err,
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            },
            {
              position: 'bottom-right',
            })
          },
        )
    },
    onClear() {
      this.chatmessageData.type = 'flex'
      this.chatmessageData.source = ''
      this.chatmessageData.message = ''
      this.chatmessageData.baseUrl = ''
      this.chatmessageData.textMessage = ''
      this.chatmessageData.altText = ''
      this.actionData = null
    },
    onCopy() {
      const copyText = (this.chatmessageData.message) ? JSON.stringify(this.chatmessageData.message) : ''
      navigator.clipboard.writeText(copyText).then(() => {
        const okMsg = this.$i18n.t('Copied to clipboard')
        this.$toast({
          component: ToastificationContent,
          props: {
            title: okMsg,
            icon: 'CheckCircleIcon',
            variant: 'success',
          },
        },
        {
          position: 'top-center',
        })
      })
    },
    onAction(action) {
      this.actionData = action
    },
    toggleShowLineMessage() {
      this.isShowLineMessage = !this.isShowLineMessage
    },
  },
  setup() {
    const {
      refFormObserver,
      getValidationState,
      resetForm,
      clearForm,
    } = formValidation()

    return {
      resetForm,
      clearForm,
      refFormObserver,
      getValidationState,
    }
  },
}
</script>

<style lang="scss">
@import '~@core/scss/base/bootstrap-extended/_variables';
@import '~@core/scss/base/bootstrap-extended/include';
@import '~@core/scss/base/components/variables-dark';

.modal{
  .line-height-info{
    padding-bottom: 0.6rem;
    &.end{
      padding-bottom: 0;
    }
  }
  .modal-header,
  .modal-header[class*='bg-'] {
    background-color: #fff !important;
  }
  .modal-body {
    background-color: $body-bg !important;
  }
}
.form-info-box{
  display: flex;
  padding: 0.6rem 1rem;
  background-color: #f8f8f8;
  background-clip: padding-box;
  border: 1px solid #f0f0f0;
  border-radius: 0.357rem;
}

.dark-layout {
  .modal{
    .line-height-info{
      padding-bottom: 0.6rem;
      &.end{
        padding-bottom: 0;
      }
    }
    .modal-header,
    .modal-header[class*='bg-'] {
      background-color: $theme-dark-body-bg !important;
    }
    .modal-body {
      background-color: $theme-dark-table-active-bg !important;
    }
  }
  .form-info-box{
    display: flex;
    padding: 0.6rem 1rem;
    background-color: $theme-dark-input-bg;
    background-clip: padding-box;
    border: 1px solid $theme-dark-border-color;
    border-radius: 0.357rem;
  }
}
.jsoneditor-poweredBy {
  display: none !important;
}
.jsoneditor {
  border: thin solid #d8d6de !important;
}
.jsoneditor-menu{
  background-color: #aaaaaa !important;
  border-bottom: 1px solid #aaaaaa !important;
}
</style>
